// tenantListSlice.js
import { createSlice } from "@reduxjs/toolkit";
import { safeParse } from "../../helper/helper";

const initialState = [];

const tenantListSlice = createSlice({
  name: "tenantList",
  initialState,
  reducers: {
    setTenantList: (state, action) => {
      safeParse(
        sessionStorage.setItem("tenantList", JSON.stringify(action.payload)),
      );
      return action.payload; // ✅ replace whole array
    },
    clearTenantList: () => {
      safeParse(sessionStorage.removeItem("tenantList"));
      return []; // ✅ reset array
    },
  },
});

export const { setTenantList, clearTenantList } = tenantListSlice.actions;

export default tenantListSlice.reducer;
